const firebaseCred = {
  apiKey: "AIzaSyBhxnD9vTWRGTczzzqMQA3ihqXK7rOU1uc",
  authDomain: "covi-help-83966.firebaseapp.com",
  projectId: "covi-help-83966",
  storageBucket: "covi-help-83966.appspot.com",
  messagingSenderId: "66761802917",
  appId: "1:66761802917:web:6bed7919e17c9b312e394c"
};

export default firebaseCred;